import { useCallback } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { save_z3k_settings, Z3KSettingsUpdateReason } from 'z3k-settings/redux/actions';
import { changeConfigBySettingsMaster } from '../lib/change-config';
import { selectDeviceFields } from 'entities/device/lib/selectors';
import { createSelector } from 'reselect';
import { openErrorDialog } from 'console/dialogs/error/redux/actions';
import { useAdditionalSaveSettingsMaster } from 'features/settings-master/lib/additional-settings';
// TODO: add location; add timezone; add sim_card
export const selectDeviceForMasterSetting = (device_id) => createSelector(selectDeviceFields(device_id, [
    'id',
    'z3k_config',
    'is_configured_by_wizard',
    'hardware_type',
    'device_type',
]), (dev) => (dev != null ? dev : null));
const default_config = {
    counters: {},
    device: {
        name: 'H1V',
        hardware: '715',
        firmware: '259',
    },
    login: '',
    timezone: 3,
    port: 52200,
};
export const useSaveMasterSettings = (device_id, path, dataSelectSettings) => {
    const device = useAppSelector(selectDeviceForMasterSetting(device_id));
    const onOpenErrorDialog = useAction(openErrorDialog);
    const changeConfig = useCallback(() => {
        if (device != null) {
            try {
                return changeConfigBySettingsMaster(dataSelectSettings, device.z3k_config ?? default_config, path, !!device.is_configured_by_wizard);
            }
            catch (e) {
                onOpenErrorDialog({ error: e, error_ui: e.toString() });
            }
        }
        return null;
    }, [device, path]);
    const _onSave = useAction(save_z3k_settings);
    const additionalUpdate = useAdditionalSaveSettingsMaster(device_id, path);
    const onSave = useCallback((config) => {
        if (device != null && config != null) {
            _onSave(config, [
                {
                    object_id: null,
                    command_name: 'RestartDevice',
                    command_args: null,
                },
            ], device.id, null, Z3KSettingsUpdateReason.ZontWizard);
        }
    }, [_onSave, device]);
    const onSaveConfig = useCallback(() => {
        const result_config = changeConfig();
        onSave(result_config);
        additionalUpdate(result_config);
    }, [onSave, changeConfig, additionalUpdate]);
    return onSaveConfig;
};
